<button class="opportunities-btn" type="button" (click)="onClick()">
  <svg>
    <use href="assets/icons.svg#graph"></use>
  </svg>
  My Opportunities
</button>
